import Vue from 'vue'

export const TOAST_DURATION = 5000

export const toastState = Vue.observable({
	toasts: []
})

export function addToast (notification) {
	if (toastState.toasts.some(toast => toast.id === notification.id)) return
	toastState.toasts = [...toastState.toasts, notification]
}

export function removeToast (notification) {
	toastState.toasts = toastState.toasts.filter(toast => toast.id !== notification.id)
}

export function clearToasts () {
	toastState.toasts = []
}
